export function isSubscriptionRequiredError(e) {
  const data = e?.response?.data || {};
  return e?.response?.status === 403 && data.error === "subscription_required";
}
